<script lang="ts" setup>
import Simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
</script>

<template>
  <Simplebar
    data-simplebar-auto-hide="false"
    data-simplebar-scrollable-x="false"
    data-simplebar-scrollable-y
    :tab-index="-1"
    :class="[
      'h-full w-full flex',
      'simplebar-vertical:w-2',
      'simplebar-scrollbar.simplebar-visible:before:bg-gray-100',
    ]"
  >
    <slot />
  </Simplebar>
</template>
